// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"243":"styling","345":"portfolio","353":"contact"}[chunkId] || chunkId) + "." + {"243":"6d7dd1d8","345":"c70425c4","353":"50450e6f","366":"9240e850"}[chunkId] + ".js";
};